import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
const FileUploadProductB = ({ onUploadSuccess }) => {
  const [file, setFile] = useState(null);
  const [file2, setFile2] = useState(null);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null);
  const [statusCC, setStatusCC] = useState(null);
  const [statusTF, setStatusTF] = useState(null);
  const [errorCodeCC, setErrorCodeCC] = useState(null);
  const [riverchainID, setRiverchainID] = useState(null);
  const [borrowerNameEng, setBorroerNameEng] = useState(null);
  const [borrowerNameChinese, setBorrowerNameChinese] = useState(null);
  const [finalUpload, setFinalUpload] = useState(false);
  const [registeredAddress, setRegisteredAddress] = useState(null);
  const [placeofincorporation, setPlaceofincorporation] = useState(null);
  const [contactname, setContactname] = useState(null);
  const [contactemailaddress, setContactemailaddress] = useState(null);
  const [contactphonenumber, setContactphonenumber] = useState(null);
  const [businessRegistrationNumber, setBusinessRegistrationNumber] =
    useState(null);
  const [bankName, setBankName] = useState(null);
  const [bankAccNo, setBankAccNo] = useState(null);
  const [benifiserName, setBenifiserName] = useState(null);
  const [bankCode, setBankCode] = useState(null);
  const [swift, setSwift] = useState(null);

  const [statusRes, setStatusRes] = useState(null);

  //   TF
  const [errorCodeTF, SetErrorCodeTF] = useState(null);
  const [lenderNo, setLenderNo] = useState(null);
  const [productNo, setProductNo] = useState(null);
  const [facilityLimit, setFacilityLimit] = useState(null);
  const [drawDownAvailability, SetDrawDownAvailability] = useState(null);
  const [interestRate, setInterestRate] = useState(null);
  const [maxTerm, setMaxTerm] = useState(null);
  const [repaymentOne, setRepaymentOne] = useState(null);
  const [invoiceAmount, setInvoiceAmount] = useState(null);
  const [invoiceAmount2, setInvoiceAmount2] = useState(null);
  const [invoiceAmountFinal, setInvoiceAmountFinal] = useState(null);
  const [invoiceFinancing, setInvoiceFinancing] = useState(null);
  const [projectDetails, setProjectDetails] = useState(null);
  const [contractStartDate, setContractStartDate] = useState(null);
  const [invoiceNo, setInvoiceNo] = useState(null);
  const [invoiceNo2, setInvoiceNo2] = useState(null);
  const [invoiceNo3, setInvoiceNo3] = useState(null);
  const [invoiceDate, setInvoiceDate] = useState(null);
  const [invoiceDate2, setInvoiceDate2] = useState(null);
  const [invoiceDate3, setInvoiceDate3] = useState(null);
  const [borrowerContractor, setBorrowerContractor] = useState(null);
  const [adminFee, setAdminFee] = useState(null);
  const [subContractorNo, setSubContractorNo] = useState(null);
  const [employer, setEmployer] = useState(null);
  const [contractType, setContractType] = useState(null);
  const [contractType2, setContractType2] = useState(null);
  const [contractType3, setContractType3] = useState(null);
  const [subContractNo2, setSubContractNo2] = useState(null);
  const [subContractNo3, setSubContractNo3] = useState(null);
  const [subContractprojectDetails, setSubContractprojectDetails] =
    useState(null);
  const [subContractprojectDetails3, setSubContractprojectDetails3] =
    useState(null);
  const [subContractStartDate, setSubContractStartDate] = useState(null);
  const [subContractStartDate3, setSubContractStartDate3] = useState(null);
  const [emp2, setEmp2] = useState(null);
  const [emp3, setEmp3] = useState(null);
  const [borowwersContractor2, setBorowwersContractor2] = useState(null);
  const [borowwersContractor3, setBorowwersContractor3] = useState(null);
  const [paymentCertvalue, setPaymentCertvalue] = useState(null);
  const [certiCumValue, setCertiCumValue] = useState();
  const [subContractInvoiceAmount2, setSubContractInvoiceAmount2] =
    useState(null);

  const [subContractInvoiceAmount3, setSubContractInvoiceAmount3] =
    useState(null);
  const fileInputRef = useRef(null);
  const fileInputRef2 = useRef(null);

  const BACKEND_URL = "https://atlas.docauto.riverchain.xyz";
  const API_URL = "https://atlas.docauto.riverchain.xyz/api";

  function formatNewDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0"); // Ensure 2 digits
    const monthFull = date.toLocaleString("default", { month: "long" });
    const month = monthFull.slice(0, 3); // Take only the first 3 letters
    const year = date.getFullYear();

    return `${day} ${month} ${year}`;
  }

  const handleUploadCC = async () => {
    try {
      if (!file) {
        console.error("First file is missing!");
        setStatus("Please select the first file.");
        return false;
      }

      const formData1 = new FormData();
      formData1.append("file", file);

      console.log("Uploading first file...");
      const response = await fetch(`${BACKEND_URL}/uploadfile/`, {
        method: "POST",
        body: formData1,
        headers: { Accept: "application/json" },
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Server error: ${response.status} - ${errorText}`);
      }
      const data = await response.json();
      console.log("First file uploaded successfully:", data);
      setPlaceofincorporation(
        data.content?.Placeofincorporation != null
          ? data.content?.Placeofincorporation
          : ""
      );
      setBorrowerNameChinese(
        data.content?.CompanyName_Chinese != null
          ? data.content?.CompanyName_Chinese
          : ""
      );
      setRegisteredAddress(
        data.content?.RegisteredAddress != null
          ? data.content?.RegisteredAddress
          : ""
      );
      setContactname(
        data.content?.Contactname != null ? data.content?.Contactname : ""
      );
      setContactemailaddress(
        data.content?.Contactemailaddress != null
          ? data.content?.Contactemailaddress
          : ""
      );
      setContactphonenumber(
        data.content?.Contactphonenumber != null
          ? data.content?.Contactphonenumber
          : ""
      );
      setBusinessRegistrationNumber(
        data.content?.BusinessRegistrationNumber != null
          ? data.content?.BusinessRegistrationNumber
          : ""
      );
      setBankAccNo(
        data.content?.BankAccountNumber !== null
          ? data.content?.BankAccountNumber
          : ""
      );
      setBankName(data.content?.BankName != null ? data.content?.BankName : "");
      setBenifiserName(
        data.content?.BeneficiaryName !== null
          ? data.content?.BeneficiaryName
          : ""
      );
      setBankCode(
        data.content?.BankCode !== null ? data.content?.BankCode : ""
      );
      setSwift(data.content?.SWIFT !== null ? data.content?.SWIFT : "");
      setErrorCodeCC(data.content?.status);

      return true;
    } catch (error) {
      console.error("Error uploading first file:", error);
      setStatus("Error uploading first file. Check console for details.");
      return false;
    }
  };

  const handleUploadTF = async () => {
    try {
      if (!file2) {
        console.error("Second file is missing!");
        setStatus("Please select the second file.");
        return;
      }
      const formData2 = new FormData();
      formData2.append("file", file2);

      console.log("Uploading second file...");
      const response = await fetch(`${BACKEND_URL}/uploadTFPRODBfile/`, {
        method: "POST",
        body: formData2,
        headers: { Accept: "application/json" },
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Server error: ${response.status} - ${errorText}`);
      }
      const data = await response.json();
      console.log("Second file uploaded successfully:", data);

      SetErrorCodeTF(data.contentTF?.status);
      setRiverchainID(data.contentTF?.TRANSACTIONID);
      setBorroerNameEng(data.contentTF?.BORROWER);
      setLenderNo(
        data.contentTF?.LENDER_NO !== null ? data.contentTF?.LENDER_NO : ""
      );
      setProductNo(
        data.contentTF?.PRODUCT_NO !== null ? data.contentTF?.PRODUCT_NO : ""
      );
      setFacilityLimit(
        data.contentTF?.FACILITYLIMIT_HK !== null
          ? data.contentTF?.FACILITYLIMIT_HK
          : ""
      );
      SetDrawDownAvailability(
        data.contentTF?.AVAILABILITYPERIOD_DAYS_MONTHS !== null
          ? data.contentTF?.AVAILABILITYPERIOD_DAYS_MONTHS
          : ""
      );
      setInterestRate(
        data.contentTF?.INTERESTRATE !== null
          ? (data.contentTF?.INTERESTRATE * 100).toFixed(2)
          : ""
      );
      setMaxTerm(
        data.contentTF?.MAXTERM_DAYS !== null
          ? data.contentTF?.MAXTERM_DAYS
          : ""
      );
      setRepaymentOne(
        data.contentTF?.REPAYMENT_NO_1 !== null
          ? data.contentTF?.REPAYMENT_NO_1
          : ""
      );

      setInvoiceFinancing(
        data.contentTF?.DRAWDOWNLIMIT_PERCENTAGE_ !== null
          ? data.contentTF?.DRAWDOWNLIMIT_PERCENTAGE_
          : ""
      );

      setProjectDetails(
        data.contentTF?.MAINCONTRACT !== null
          ? data.contentTF?.MAINCONTRACT
          : ""
      );
      setContractStartDate(
        data.contentTF?.CONTRACTSTARTDATE !== null
          ? data.contentTF?.CONTRACTSTARTDATE
          : ""
      );
      setInvoiceNo(
        data.contentTF?.INVOICENO !== null ? data.contentTF?.INVOICENO : ""
      );

      console.log("Invoice no", invoiceNo);

      setInvoiceNo2(
        data.contentTF?.INVOICENO_2 !== null ? data.contentTF?.INVOICENO_2 : ""
      );

      setInvoiceNo3(
        data.contentTF?.INVOICENO_3 !== null ? data.contentTF?.INVOICENO_3 : ""
      );

      setInvoiceAmount(
        data.contentTF?.INVOICEVALUE_HK !== null
          ? data.contentTF?.INVOICEVALUE_HK
          : ""
      );

      setInvoiceAmount2(
        data.contentTF?.INVOICEVALUE_HK_2 !== null
          ? data.contentTF?.INVOICEVALUE_HK_2
          : ""
      );

      const raw =
        data.contentTF?.INVOICEVALUE_HK ||
        data.contentTF?.INVOICEVALUE_HK_2 ||
        "00";

      setInvoiceAmountFinal(raw);

      setSubContractInvoiceAmount2(
        data.contentTF?.INVOICEVALUE_HK_2 !== null
          ? data.contentTF?.INVOICEVALUE_HK_2
          : ""
      );

      setSubContractInvoiceAmount3(
        data.contentTF?.INVOICEVALUE_HK_3 !== null
          ? data.contentTF?.INVOICEVALUE_HK_3
          : ""
      );

      console.log("Invoice amount Final:", invoiceAmountFinal);

      setInvoiceDate(
        data.contentTF?.INVOICEDATE !== null ? data.contentTF?.INVOICEDATE : ""
      );

      setInvoiceDate2(
        data.contentTF?.INVOICEDATE_2 !== null
          ? data.contentTF?.INVOICEDATE_2
          : ""
      );

      setInvoiceDate3(
        data.contentTF?.INVOICEDATE_3 !== null
          ? data.contentTF?.INVOICEDATE_3
          : ""
      );

      setBorrowerContractor(
        data.contentTF?.MAINCONTRACTOR !== null
          ? data.contentTF?.MAINCONTRACTOR
          : ""
      );
      setAdminFee(
        data.contentTF?.ADMINFEE !== null
          ? (data.contentTF?.ADMINFEE * 100).toFixed(2)
          : ""
      );
      setSubContractorNo(
        data.contentTF?.SUBCONTRACT !== null ? data.contentTF?.SUBCONTRACT : ""
      );
      setEmployer(
        data.contentTF?.EMPLOYER !== null ? data.contentTF?.EMPLOYER : ""
      );
      setContractType(
        data.contentTF?.CONTRACTTYPE_NO !== null
          ? data.contentTF?.CONTRACTTYPE_NO
          : ""
      );

      setContractType2(
        data.contentTF?.CONTRACTTYPE_NO_2 !== null
          ? data.contentTF?.CONTRACTTYPE_NO_2
          : ""
      );

      setContractType3(
        data.contentTF?.CONTRACTTYPE_NO_3 !== null
          ? data.contentTF?.CONTRACTTYPE_NO_3
          : ""
      );

      setSubContractNo2(
        data.contentTF?.SUBCONTRACT_2 !== null
          ? data.contentTF?.SUBCONTRACT_2
          : ""
      );

      setSubContractNo3(
        data.contentTF?.SUBCONTRACT_3 !== null
          ? data.contentTF?.SUBCONTRACT_3
          : ""
      );

      setSubContractprojectDetails(
        data.contentTF?.MAINCONTRACT_2 !== null
          ? data.contentTF?.MAINCONTRACT_2
          : ""
      );

      setSubContractprojectDetails3(
        data.contentTF?.MAINCONTRACT_3 !== null
          ? data.contentTF?.MAINCONTRACT_3
          : ""
      );

      setSubContractStartDate(
        data.contentTF?.CONTRACTSTARTDATE_2 !== null
          ? data.contentTF?.CONTRACTSTARTDATE_2
          : ""
      );
      setSubContractStartDate3(
        data.contentTF?.CONTRACTSTARTDATE_3 !== null
          ? data.contentTF?.CONTRACTSTARTDATE_3
          : ""
      );
      setEmp2(
        data.contentTF?.EMPLOYER_2 !== null ? data.contentTF?.EMPLOYER_2 : ""
      );
      setEmp3(
        data.contentTF?.EMPLOYER_3 !== null ? data.contentTF?.EMPLOYER_3 : ""
      );
      setBorowwersContractor2(
        data.contentTF?.MAINCONTRACTOR_2 !== null
          ? data.contentTF?.MAINCONTRACTOR_2
          : ""
      );
      setBorowwersContractor3(
        data.contentTF?.MAINCONTRACTOR_3 !== null
          ? data.contentTF?.MAINCONTRACTOR_3
          : ""
      );
      setPaymentCertvalue(
        data.contentTF?.PAYMENTCERTVALUE_HK !== null
          ? data.contentTF?.PAYMENTCERTVALUE_HK
          : ""
      );
      setCertiCumValue(
        data.contentTF?.CERTIFIEDTODATE_EXCLVO_HK !== null
          ? data.contentTF?.CERTIFIEDTODATE_EXCLVO_HK
          : ""
      );
      return true;
    } catch (error) {
      console.error("Error uploading second file:", error);
      setStatus("Upload failed, please check the uploaded file");
    }
  };

  const handleUpload = async () => {
    if (!file || !file2) {
      setStatus("Please select both files before uploading.");
      return;
    }
    setLoading(true);
    setStatus("Uploading first file...");

    if (errorCodeCC === "ERROR") {
      // setStatus("Somethig wrong with the Transaction File");
      setLoading(true);
      console.log("Loading:", loading);
      return;
    }

    if (errorCodeTF === "ERROR") {
      // setStatus("Somethig wrong with the Transaction File");
      setLoading(true);
      console.log("Loading:", loading);
      return;
    }

    const firstFileSuccess = await handleUploadCC();

    if (firstFileSuccess) {
      console.log("First upload successful, now uploading second file...");
      setStatus("Uploading second file...");
      setFinalUpload(true);
      await handleUploadTF();
    } else {
      console.log("First upload failed, skipping second upload.");
    }

    setLoading(false);
  };

  useEffect(() => {
    if (errorCodeCC === "ERROR") {
      // setStatus("Somethig wrong with the Transaction File");
      setLoading(true);
      console.log("Loading:", loading);
      return;
    }

    if (errorCodeTF === "ERROR") {
      // setStatus("Somethig wrong with the Transaction File");
      setLoading(true);
      console.log("Loading:", loading);
      return;
    }

    // compantNameEng
    if (errorCodeCC === "OK" && errorCodeTF === "OK") {
      const newStartDate =
        contractStartDate && contractStartDate !== null
          ? formatNewDate(contractStartDate)
          : "";

      const newInvoiceDate =
        invoiceDate && invoiceDate !== null ? formatNewDate(invoiceDate) : "";

      const newInvoiceDate2 =
        invoiceDate2 && invoiceDate2 !== null
          ? formatNewDate(invoiceDate2)
          : "";

      const newInvoiceDate3 =
        invoiceDate3 && invoiceDate3 !== null
          ? formatNewDate(invoiceDate3)
          : "";

      const newSubConStartDate =
        subContractStartDate && subContractStartDate !== null
          ? formatNewDate(subContractStartDate)
          : "";

      const newSubConStartDate3 =
        subContractStartDate3 && subContractStartDate3 !== null
          ? formatNewDate(subContractStartDate3)
          : "";

      const newsubContractNo2 =
        subContractNo2 === undefined
          ? ""
          : subContractNo2 !== null
          ? subContractNo2
          : "";

      const newsubContractNo3 =
        subContractNo3 === undefined
          ? ""
          : subContractNo3 !== null
          ? subContractNo3
          : "";

      const newborrowerContractor =
        borrowerContractor === undefined
          ? ""
          : borrowerContractor !== null
          ? borrowerContractor
          : "";

      const newBororwersContractor2 =
        borowwersContractor2 === undefined
          ? ""
          : borowwersContractor2 !== null
          ? borowwersContractor2
          : "";

      const newBororwersContractor3 =
        borowwersContractor3 === undefined
          ? ""
          : borowwersContractor3 !== null
          ? borowwersContractor3
          : "";

      const newsubContractorprojectDetails =
        subContractprojectDetails === undefined
          ? ""
          : subContractprojectDetails !== null
          ? subContractprojectDetails
          : "";

      const newsubContractorprojectDetails3 =
        subContractprojectDetails3 === undefined
          ? ""
          : subContractprojectDetails3 !== null
          ? subContractprojectDetails3
          : "";

      const newpaymentCertvalue =
        paymentCertvalue === undefined
          ? "00.00"
          : paymentCertvalue !== "n/a"
          ? paymentCertvalue
          : "";

      const newInvoiceNo = invoiceNo ?? invoiceNo2;

      const newContractType2 = contractType2 !== undefined ? contractType2 : "";

      const newInvoiceNo2 = invoiceNo2 !== undefined ? invoiceNo2 : "";

      const newInvoiceNo3 = invoiceNo3 !== undefined ? invoiceNo3 : "";

      const newemp2 = emp2 === undefined ? "" : emp2 !== null ? emp2 : "";

      const newemp3 = emp3 === undefined ? "" : emp3 !== null ? emp3 : "";

      const newInvoiceFinancing = invoiceFinancing && invoiceFinancing * 100;

      const xmlData = `<?xml version="1.0" encoding="UTF-8"?>
<isheet recordcount="string">
	<id>0</id>
	<title>string</title>
	<description>string</description>
	<status>string</status>
	<accesstype>string</accesstype>
	<type>string</type>
	<viewlink>string</viewlink>
	<allowsections>string</allowsections>
	<allowlookup>string</allowlookup>
	<displayisheet>string</displayisheet>
	<searchasdefaultview>string</searchasdefaultview>
	<enableversion>string</enableversion>
	<enablesheetalerter>string</enablesheetalerter>
	<alertercondition>string</alertercondition>
	<overrideitemmodifieddate>string</overrideitemmodifieddate>
	<enablebulkinsertupdate>string</enablebulkinsertupdate>
	<fielddescriptions>string</fielddescriptions>
	<enablerowlocking>string</enablerowlocking>
	<setcharlimittruncatemultilinetextenabled>string</setcharlimittruncatemultilinetextenabled>
	<setcharlimittruncatemultilinetextval>string</setcharlimittruncatemultilinetextval>
	<allowchoicelistvaluesforreuse>string</allowchoicelistvaluesforreuse>
	<allowscorelistvaluesforreuse>string</allowscorelistvaluesforreuse>
	<allowIsheetComments>string</allowIsheetComments>
	<shareRecordsLimit>0</shareRecordsLimit>
	<shareRecordsLimitEnabled>0</shareRecordsLimitEnabled>
	<enableIsheetAddRecordFormSharing>string</enableIsheetAddRecordFormSharing>
	<allowViewBaseRendering>string</allowViewBaseRendering>
	<columns>
		<column sequence="string" attributecolumnid="string">
			<columnid>0</columnid>
			<name>test</name>
			<type>0</type>
			<status>0</status>
			<systemgeneratedtype>string</systemgeneratedtype>
			<section>0</section>
			<description>string</description>
			<addtodefaultview>string</addtodefaultview>
			<columnconditionstate>string</columnconditionstate>
			<columnconditions>
				<row>
					<rowid>0</rowid>
					<columnid>0</columnid>
					<operatorid>0</operatorid>
					<oprand>string</oprand>
					<logicaltype>string</logicaltype>
					<sheetfiltervaluetypeid>string</sheetfiltervaluetypeid>
					<displaytype>string</displaytype>
					<scoreConditionTypeid>0</scoreConditionTypeid>
					<sourceColumnId>0</sourceColumnId>
				</row>
			</columnconditions>
			<columnspecificdetail>
				<defaultvalue>string</defaultvalue>
				<columnwidth>string</columnwidth>
				<sheetname>string</sheetname>
				<sitename>string</sitename>
				<mandatory>string</mandatory>
				<allowsearch>string</allowsearch>
				<maxchars>0</maxchars>
				<allowfieldfromanotherisheet>string</allowfieldfromanotherisheet>
				<allowrichhtmltext>string</allowrichhtmltext>
				<numberoflines>0</numberoflines>
				<displaymethod>string</displaymethod>
				<includeotheroption>string</includeotheroption>
				<singleormultileselectioninsearch>string</singleormultileselectioninsearch>
				<choices>
					<choice>
						<id>string</id>
						<label>string</label>
						<score>string</score>
						<color>string</color>
						<imageid>0</imageid>
					</choice>
				</choices>
				<includeinalertpreferences>string</includeinalertpreferences>
				<min>string</min>
				<max>string</max>
				<decimalplaces>0</decimalplaces>
				<showthousandseparators>string</showthousandseparators>
				<showaspercentage>string</showaspercentage>
				<symbolId>string</symbolId>
				<numberDecimalFormat>DOT_AS_DECIMAL/COMMA_AS_DECIMAL</numberDecimalFormat>
				<symbolPosition>before/after</symbolPosition>
				<formattype>string</formattype>
				<dateformat>string</dateformat>
				<defaultdateandtime>string</defaultdateandtime>
				<sheetlookup>string</sheetlookup>
				<fielddisplay>string</fielddisplay>
				<allowmultipleusers>string</allowmultipleusers>
				<methodtype>string</methodtype>
				<sheetids>string</sheetids>
				<allowuserstorenamelinks>string</allowuserstorenamelinks>
				<sheetid>0</sheetid>
				<columnids>string</columnids>
				<viewid>0</viewid>
				<allowmultiplevalues>string</allowmultiplevalues>
				<restrictdelete>string</restrictdelete>
				<displaycolumnnameprefix>string</displaycolumnnameprefix>
				<linkname>string</linkname>
				<donotcountweekendsonlycountmontofri>string</donotcountweekendsonlycountmontofri>
				<joinconditions>
					<joincondition>
						<currentsheetcolumnid>0</currentsheetcolumnid>
						<targetsheetcolumnid>0</targetsheetcolumnid>
					</joincondition>
				</joinconditions>
				<formula>string</formula>
				<startvalue>0</startvalue>
				<prefix>string</prefix>
				<postfix>string</postfix>
				<minlength>0</minlength>
				<lookupglossarysheetid>0</lookupglossarysheetid>
				<lookupglossarysheetviewid>0</lookupglossarysheetviewid>
				<width>0</width>
				<otherscorevalue>string</otherscorevalue>
				<importdatafromexternalsource>string</importdatafromexternalsource>
				<analysisengine>string</analysisengine>
				<attachmentcustomfolderid/>
				<singleLineEmailValidation>string</singleLineEmailValidation>
				<readonly>string</readonly>
				<virtualColumn>0</virtualColumn>
				<externalSource>string</externalSource>
				<allowInlineEditing>string</allowInlineEditing>
			</columnspecificdetail>
			<rawdata>
				<value>string</value>
				<choices>
					<choice>
						<id>string</id>
						<label>string</label>
						<score>string</score>
						<color>string</color>
						<imageid>0</imageid>
					</choice>
				</choices>
				<date>string</date>
				<time>string</time>
				<linkdisplayname>string</linkdisplayname>
				<linkdisplayurl>string</linkdisplayurl>
				<lookups>
					<lookup>
						<id>string</id>
						<email>string</email>
						<userlookuptype>string</userlookuptype>
					</lookup>
				</lookups>
				<folders>
					<folder>
						<folderid>string</folderid>
					</folder>
				</folders>
				<documents>
					<document>
						<docid>string</docid>
					</document>
				</documents>
				<fromdate>string</fromdate>
				<todate>string</todate>
				<attachments>
					<attachment>
						<file>string</file>
						<name>string</name>
						<order>string</order>
						<id>0</id>
						<extension>string</extension>
						<parentfolderid>0</parentfolderid>
						<filehttplink>string</filehttplink>
						<folderpath>string</folderpath>
						<folderhttplink>string</folderhttplink>
						<filesize>0</filesize>
						<redactionstatus>true</redactionstatus>
						<siteid>0</siteid>
						<displayname>string</displayname>
					</attachment>
				</attachments>
				<isheetitems>
					<isheetitem>
						<recordid>string</recordid>
						<linkname>string</linkname>
						<apilink>string</apilink>
						<httplink>string</httplink>
					</isheetitem>
				</isheetitems>
				<daydifference>string</daydifference>
			</rawdata>
			<colViewPosition>0</colViewPosition>
			<columntype>string</columntype>
			<createdDate>2025-04-08T07:16:21.504Z</createdDate>
			<modifiedDate>2025-04-08T07:16:21.504Z</modifiedDate>
			<injectReferenceColumn>0</injectReferenceColumn>
			<parentColumnID>0</parentColumnID>
			<reusecolumnidfromisheet>0</reusecolumnidfromisheet>
			<choicelistid>0</choicelistid>
			<editpermission>0</editpermission>
			<templatesheetcolumnid>0</templatesheetcolumnid>
			<uploadpermission>0</uploadpermission>
			<deletepermission>0</deletepermission>
			<sourceSheetID>0</sourceSheetID>
		</column>
	</columns>
	<metadata>
		<viewName>string</viewName>
		<viewId>0</viewId>
		<sheetName>string</sheetName>
		<siteId>0</siteId>
		<siteName>string</siteName>
		<sheetId>0</sheetId>
	</metadata>
	<head>
      <headcolumn sequence="1" columntypealias="SHEET_COLUMN_TYPE_LOOKUP" columntypeid="6" columnid="741">
        <columnvalue><![CDATA[Created by]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="2" columntypealias="SHEET_COLUMN_TYPE_DATE_AND_TIME" columntypeid="5" columnid="2001">
        <columnvalue><![CDATA[Created date]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="3" columntypealias="SHEET_COLUMN_TYPE_LOOKUP" columntypeid="6" columnid="2002">
        <columnvalue><![CDATA[Modified by]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="4" columntypealias="SHEET_COLUMN_TYPE_DATE_AND_TIME" columntypeid="5" columnid="2003">
        <columnvalue><![CDATA[Modified date]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="5" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2004">
        <columnvalue><![CDATA[Riverchain ID]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="6" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2005">
        <columnvalue><![CDATA[Borrower Name English]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="7" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2006">
        <columnvalue><![CDATA[Borrower Name Chinese]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="8" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2007">
        <columnvalue><![CDATA[Borrower BR No.]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="9" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2008">
        <columnvalue><![CDATA[Borrower Contact Details - Person]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="10" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2009">
        <columnvalue><![CDATA[Borrower Contact Details - Phone]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="11" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2010">
        <columnvalue><![CDATA[Borrower Contact Details - Email]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="12" columntypealias="SHEET_COLUMN_TYPE_MULTIPLE_LINE_TEXT" columntypeid="2" columnid="2011">
        <columnvalue><![CDATA[Borrower Address]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="13" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2012">
        <columnvalue><![CDATA[Borrower Place of Incorporation]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="14" columntypealias="SHEET_COLUMN_TYPE_CHOICE" columntypeid="3" columnid="2013">
        <columnvalue><![CDATA[Lender Company Name]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="15" columntypealias="SHEET_COLUMN_TYPE_CHOICE" columntypeid="3" columnid="2014">
        <columnvalue><![CDATA[Loan Type (2.1)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="16" columntypealias="SHEET_COLUMN_TYPE_CHOICE" columntypeid="3" columnid="2015">
        <columnvalue><![CDATA[Loan Type 2.2]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="17" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="2016">
        <columnvalue><![CDATA[Facility Limit (2.1)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="18" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="2017">
        <columnvalue><![CDATA[Facility Limit (2.2)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="19" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="2018">
        <columnvalue><![CDATA[Final Maturity Period]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="20" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2019">
        <columnvalue><![CDATA[Drawdown Availability Period]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="21" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="2020">
        <columnvalue><![CDATA[Interest Rates]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="22" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="2021">
        <columnvalue><![CDATA[HIBOR Interest Rates]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="23" columntypealias="SHEET_COLUMN_TYPE_CHOICE" columntypeid="3" columnid="2022">
        <columnvalue><![CDATA[Repayment Type (2.1)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="24" columntypealias="SHEET_COLUMN_TYPE_CHOICE" columntypeid="3" columnid="2023">
        <columnvalue><![CDATA[Repayment Type 2]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="25" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="2024">
        <columnvalue><![CDATA[Invoice amount]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="26" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="2025">
        <columnvalue><![CDATA[Invoice Financing %]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="27" columntypealias="SHEET_COLUMN_TYPE_MULTIPLE_LINE_TEXT" columntypeid="2" columnid="2026">
        <columnvalue><![CDATA[Borrower's Contractor]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="28" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="2027">
        <columnvalue><![CDATA[Admin Fee]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="29" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2028">
        <columnvalue><![CDATA[Sub Contract No. (1)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="30" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2029">
        <columnvalue><![CDATA[Sub Contract Project Details (1)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="31" columntypealias="SHEET_COLUMN_TYPE_DATE_AND_TIME" columntypeid="5" columnid="2030">
        <columnvalue><![CDATA[sub contract date (1)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="32" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2031">
        <columnvalue><![CDATA[Sub Contract Invoice No (1)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="33" columntypealias="SHEET_COLUMN_TYPE_DATE_AND_TIME" columntypeid="5" columnid="2032">
        <columnvalue><![CDATA[Sub contract Invoice date (1)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="34" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="2033">
        <columnvalue><![CDATA[Sub contract invoice amount (1)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="35" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2034">
        <columnvalue><![CDATA[Borrower's Bank Name]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="36" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2035">
        <columnvalue><![CDATA[Borrower's Bank Account No.]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="37" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2036">
        <columnvalue><![CDATA[Borrower's Bank Account Name]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="38" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2037">
        <columnvalue><![CDATA[Borrower's Bank Swift Code]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="39" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2038">
        <columnvalue><![CDATA[Borrower's Emoloyer (1)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="40" columntypealias="SHEET_COLUMN_TYPE_CHOICE" columntypeid="3" columnid="2039">
        <columnvalue><![CDATA[Contract Type (1)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="41" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2040">
        <columnvalue><![CDATA[Payment Application No.]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="42" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="2041">
        <columnvalue><![CDATA[Payment Application Amount]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="43" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2042">
        <columnvalue><![CDATA[Collection Agent signor name]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="44" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2043">
        <columnvalue><![CDATA[Collection Agent signor title]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="45" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2044">
        <columnvalue><![CDATA[Lender Company signor name]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="46" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2045">
        <columnvalue><![CDATA[Lender company signor title]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="47" columntypealias="SHEET_COLUMN_TYPE_CHOICE" columntypeid="3" columnid="2046">
        <columnvalue><![CDATA[Collect Agent company name]]></columnvalue>
      </headcolumn>
       <headcolumn sequence="48" columntypealias="SHEET_COLUMN_TYPE_DATE_AND_TIME" columntypeid="5" columnid="2047">
        <columnvalue><![CDATA[Payment Application date]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="49" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2048">
        <columnvalue><![CDATA[Payment Certificate Number]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="50" columntypealias="SHEET_COLUMN_TYPE_DATE_AND_TIME" columntypeid="5" columnid="2049">
        <columnvalue><![CDATA[Payment Certificate Date]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="51" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2050">
        <columnvalue><![CDATA[Payment Certificate issued by]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="52" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="2051">
        <columnvalue><![CDATA[Payment certificate amount (1)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="53" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="2052">
        <columnvalue><![CDATA[Payment Certificate amount (Cumulative)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="54" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2053">
        <columnvalue><![CDATA[Extension Approved Notice Period]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="55" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2054">
        <columnvalue><![CDATA[Extension Request Notice Period]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="56" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2055">
        <columnvalue><![CDATA[Maximum no. of extensions]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="57" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2056">
        <columnvalue><![CDATA[Number of extensions]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="58" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2057">
        <columnvalue><![CDATA[Supplier invoice issue no of days]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="59" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2058">
        <columnvalue><![CDATA[Term/Revolving Loan Purpose]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="60" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2059">
        <columnvalue><![CDATA[Term/Revolving Loan Drawdown Availability]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="61" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2060">
        <columnvalue><![CDATA[Name of Security Provider]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="62" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2061">
        <columnvalue><![CDATA[Conditions Subsequent Documents Delivery]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="63" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2062">
        <columnvalue><![CDATA[Sub Contract No. (2)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="64" columntypealias="SHEET_COLUMN_TYPE_DATE_AND_TIME" columntypeid="5" columnid="2063">
        <columnvalue><![CDATA[Sub Contract Date (2)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="65" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2064">
        <columnvalue><![CDATA[Sub Contract Project Details (2)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="66" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2065">
        <columnvalue><![CDATA[Borrower's Contractor (2)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="67" columntypealias="SHEET_COLUMN_TYPE_CHOICE" columntypeid="3" columnid="2066">
        <columnvalue><![CDATA[Collection Account Required]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="68" columntypealias="SHEET_COLUMN_TYPE_ATTACHMENT" columntypeid="9" columnid="2067">
        <columnvalue><![CDATA[Generate Document]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="69" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2068">
        <columnvalue><![CDATA[Voluntary Prepayment Notice Period]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="70" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2069">
        <columnvalue><![CDATA[Borrower's Bank Code]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="71" columntypealias="SHEET_COLUMN_TYPE_CHOICE" columntypeid="3" columnid="2070">
        <columnvalue><![CDATA[Repayment Currency]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="72" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2071">
        <columnvalue><![CDATA[Tranche 1 Drawdown days]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="73" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2072">
        <columnvalue><![CDATA[Tranche 2 Drawdown days]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="74" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="2073">
        <columnvalue><![CDATA[Default Interest Rate]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="75" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="2074">
        <columnvalue><![CDATA[Term Loan Tranche 1]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="76" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="2075">
        <columnvalue><![CDATA[Term Loan Tranche 2]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="77" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="2076">
        <columnvalue><![CDATA[Revenue Based Repaymentment Invoice Amount Percentage]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="78" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2077">
        <columnvalue><![CDATA[Sub Contract No. (3)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="79" columntypealias="SHEET_COLUMN_TYPE_DATE_AND_TIME" columntypeid="5" columnid="2078">
        <columnvalue><![CDATA[Sub Contract Date (3)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="80" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2079">
        <columnvalue><![CDATA[Sub Contract Project Details (3)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="81" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2080">
        <columnvalue><![CDATA[Borrower's Contractor (3)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="82" columntypealias="SHEET_COLUMN_TYPE_CHOICE" columntypeid="3" columnid="2081">
        <columnvalue><![CDATA[Contract Type (2)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="83" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2082">
        <columnvalue><![CDATA[Borrower's Emoloyer (2)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="84" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2083">
        <columnvalue><![CDATA[Borrower's Emoloyer (3)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="85" columntypealias="SHEET_COLUMN_TYPE_CHOICE" columntypeid="3" columnid="2084">
        <columnvalue><![CDATA[Contract Type (3)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="86" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2085">
        <columnvalue><![CDATA[Sub Contract Invoice No (2)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="87" columntypealias="SHEET_COLUMN_TYPE_DATE_AND_TIME" columntypeid="5" columnid="2086">
        <columnvalue><![CDATA[Sub contract Invoice date (2)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="88" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="2087">
        <columnvalue><![CDATA[Sub contract invoice amount (2)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="89" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2088">
        <columnvalue><![CDATA[Sub Contract Invoice No (3)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="90" columntypealias="SHEET_COLUMN_TYPE_DATE_AND_TIME" columntypeid="5" columnid="2089">
        <columnvalue><![CDATA[Sub contract Invoice date (3)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="91" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="2090">
        <columnvalue><![CDATA[Sub contract invoice amount (3)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="92" columntypealias="SHEET_COLUMN_TYPE_CHOICE" columntypeid="3" columnid="2091">
        <columnvalue><![CDATA[Sole/Multiple Director]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="93" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="2092">
        <columnvalue><![CDATA[Payment certificate amount (2)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="94" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="2093">
        <columnvalue><![CDATA[Payment certificate amount (3)]]></columnvalue>
      </headcolumn>
    </head>
    <data>
		<item externalid="" itemsequence="200" itemid="201">
        <column sequence="5" attributecolumnid="2004">
          <rawdata>
            <value><![CDATA[${riverchainID}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${riverchainID}]]></value>
          </displaydata>
        </column>
		<column sequence="6" attributecolumnid="2005">
          <rawdata>
            <value><![CDATA[${borrowerNameEng}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${borrowerNameEng}]]></value>
          </displaydata>
        </column>
		<column sequence="7" attributecolumnid="2006">
          <rawdata>
            <value><![CDATA[${borrowerNameChinese}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${borrowerNameChinese}]]></value>
          </displaydata>
        </column>
		<column sequence="8" attributecolumnid="2007">
          <rawdata>
            <value><![CDATA[${businessRegistrationNumber}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${businessRegistrationNumber}]]></value>
          </displaydata>
        </column>
		<column sequence="9" attributecolumnid="2008">
          <rawdata>
            <value><![CDATA[${contactname}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${contactname}]]></value>
          </displaydata>
        </column>
		<column sequence="10" attributecolumnid="2009">
          <rawdata>
            <value><![CDATA[${contactphonenumber}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${contactphonenumber}]]></value>
          </displaydata>
        </column>
		<column sequence="11" attributecolumnid="2010">
          <rawdata>
            <value><![CDATA[${contactemailaddress}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${contactemailaddress}]]></value>
          </displaydata>
        </column>
		<column sequence="12" attributecolumnid="2011">
          <rawdata>
            <value><![CDATA[${registeredAddress}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${registeredAddress}]]></value>
          </displaydata>
        </column>
		<column sequence="13" attributecolumnid="2012">
          <rawdata>
            <value><![CDATA[${placeofincorporation}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${placeofincorporation}]]></value>
          </displaydata>
        </column>
		<column sequence="14" attributecolumnid="2013">
          <rawdata>
				<choices>
					<choice>
							<id>${lenderNo}</id>
					</choice>
				</choices>
            </rawdata>
        </column>
		<column sequence="15" attributecolumnid="2014">
          <rawdata>
				<choices>
					<choice>
							<id>${productNo}</id>
					</choice>
				</choices>
            </rawdata>
        </column>
		<column sequence="16" attributecolumnid="2015">
          <rawdata>
				<choices>
					<choice>
							<id></id>
					</choice>
				</choices>
            </rawdata>
        </column>
        <column sequence="17" attributecolumnid="2016">
          <rawdata>
            <value><![CDATA[${facilityLimit}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${facilityLimit}]]></value>
          </displaydata>
        </column>
        <column sequence="18" attributecolumnid="2017">
          <rawdata>
            <value><![CDATA[]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[]]></value>
          </displaydata>
        </column>
        <column sequence="19" attributecolumnid="2018">
          <rawdata>
            <value><![CDATA[${maxTerm}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${maxTerm}]]></value>
          </displaydata>
        </column>
        <column sequence="20" attributecolumnid="2019">
          <rawdata>
            <value><![CDATA[${drawDownAvailability}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${drawDownAvailability}]]></value>
          </displaydata>
        </column>
        <column sequence="21" attributecolumnid="2020">
          <rawdata>
            <value><![CDATA[${interestRate}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${interestRate}]]></value>
          </displaydata>
        </column>
        <column sequence="22" attributecolumnid="2021">
          <rawdata>
            <value><![CDATA[]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[]]></value>
          </displaydata>
        </column>
        <column sequence="23" attributecolumnid="2022">
          <rawdata>
				<choices>
					<choice>
							<id>${repaymentOne}</id>
					</choice>
				</choices>
            </rawdata>
        </column>
        <column sequence="24" attributecolumnid="2023">
          <rawdata>
				<choices>
					<choice>
							<id></id>
					</choice>
				</choices>
            </rawdata>
        </column>
        <column sequence="25" attributecolumnid="2024">
          <rawdata>
            <value><![CDATA[${invoiceAmountFinal}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${invoiceAmountFinal}]]></value>
          </displaydata>
        </column>
        <column sequence="26" attributecolumnid="2025">
          <rawdata>
            <value><![CDATA[${newInvoiceFinancing}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${newInvoiceFinancing}]]></value>
          </displaydata>
        </column>
        <column sequence="27" attributecolumnid="2026">
          <rawdata>
            <value><![CDATA[${newborrowerContractor}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${newborrowerContractor}]]></value>
          </displaydata>
        </column>
        <column sequence="28" attributecolumnid="2027">
          <rawdata>
            <value><![CDATA[${adminFee}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${adminFee}]]></value>
          </displaydata>
        </column>
        <column sequence="29" attributecolumnid="2028">
          <rawdata>
            <value><![CDATA[${subContractorNo}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${subContractorNo}]]></value>
          </displaydata>
        </column>
        <column sequence="30" attributecolumnid="2029">
          <rawdata>
            <value><![CDATA[${projectDetails}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${projectDetails}]]></value>
          </displaydata>
        </column>
        <column sequence="31" attributecolumnid="2030">
          <rawdata>
            <date><![CDATA[${newStartDate}]]></date>
          </rawdata>
          <displaydata>
            <value><![CDATA[${newStartDate}]]></value>
          </displaydata>
        </column>
        <column sequence="32" attributecolumnid="2031">
          <rawdata>
            <value><![CDATA[${newInvoiceNo}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${newInvoiceNo}]]></value>
          </displaydata>
        </column>
        <column sequence="33" attributecolumnid="2032">
          <rawdata>
            <date><![CDATA[${newInvoiceDate}]]></date>
          </rawdata>
          <displaydata>
            <value><![CDATA[${newInvoiceDate}]]></value>
          </displaydata>
        </column>
        <column sequence="34" attributecolumnid="2033">
          <rawdata>
            <value><![CDATA[${invoiceAmountFinal}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${invoiceAmountFinal}]]></value>
          </displaydata>
        </column>
        <column sequence="35" attributecolumnid="2034">
          <rawdata>
            <value><![CDATA[${bankName}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${bankName}]]></value>
          </displaydata>
        </column>
        <column sequence="36" attributecolumnid="2035">
          <rawdata>
            <value><![CDATA[${bankAccNo}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${bankAccNo}]]></value>
          </displaydata>
        </column>
        <column sequence="37" attributecolumnid="2036">
          <rawdata>
            <value><![CDATA[${benifiserName}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${benifiserName}]]></value>
          </displaydata>
        </column>
        <column sequence="38" attributecolumnid="2069">
          <rawdata>
            <value><![CDATA[${bankCode}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${bankCode}]]></value>
          </displaydata>
        </column>
        <column sequence="39" attributecolumnid="2037">
          <rawdata>
            <value><![CDATA[${swift}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${swift}]]></value>
          </displaydata>
        </column>
        <column sequence="40" attributecolumnid="2038">
          <rawdata>
            <value><![CDATA[${employer}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${employer}]]></value>
          </displaydata>
        </column>
        <column sequence="41" attributecolumnid="2039">
          <rawdata>
				<choices>
					<choice>
							<id>${contractType}</id>
					</choice>
				</choices>
            </rawdata>
        </column>
        <column sequence="42" attributecolumnid="2040">
          <rawdata>
            <value><![CDATA[${newInvoiceNo}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${newInvoiceNo}]]></value>
          </displaydata>
        </column>
        <column sequence="43" attributecolumnid="2041">
          <rawdata>
            <value><![CDATA[${invoiceAmountFinal}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${invoiceAmountFinal}]]></value>
          </displaydata>
        </column>
        <column sequence="49" attributecolumnid="2047">
          <rawdata>
            <date><![CDATA[${newInvoiceDate}]]></date>
          </rawdata>
          <displaydata>
            <value><![CDATA[${newInvoiceDate}]]></value>
          </displaydata>
        </column>
        <column sequence="53" attributecolumnid="2051">
          <rawdata>
            <value><![CDATA[${newpaymentCertvalue}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${newpaymentCertvalue}]]></value>
          </displaydata>
        </column>
        <column sequence="54" attributecolumnid="2052">
          <rawdata>
            <value><![CDATA[${certiCumValue}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${certiCumValue}]]></value>
          </displaydata>
        </column>
        <column sequence="65" attributecolumnid="2062">
          <rawdata>
            <value><![CDATA[${newsubContractNo2}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${newsubContractNo2}]]></value>
          </displaydata>
        </column>
        <column sequence="66" attributecolumnid="2063">
          <rawdata>
            <date><![CDATA[${newSubConStartDate}]]></date>
          </rawdata>
          <displaydata>
            <value><![CDATA[${newSubConStartDate}]]></value>
          </displaydata>
        </column>
        <column sequence="67" attributecolumnid="2064">
          <rawdata>
            <value><![CDATA[${newsubContractorprojectDetails}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${newsubContractorprojectDetails}]]></value>
          </displaydata>
        </column>
        <column sequence="68" attributecolumnid="2065">
          <rawdata>
            <value><![CDATA[${newBororwersContractor2}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${newBororwersContractor2}]]></value>
          </displaydata>
        </column>
        <column sequence="78" attributecolumnid="2077">
          <rawdata>
            <value><![CDATA[${newsubContractNo3}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${newsubContractNo3}]]></value>
          </displaydata>
        </column>
        <column sequence="79" attributecolumnid="2078">
          <rawdata>
            <date><![CDATA[${newSubConStartDate3}]]></date>
          </rawdata>
          <displaydata>
            <value><![CDATA[${newSubConStartDate3}]]></value>
          </displaydata>
        </column>
        <column sequence="80" attributecolumnid="2079">
          <rawdata>
            <value><![CDATA[${newsubContractorprojectDetails3}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${newsubContractorprojectDetails3}]]></value>
          </displaydata>
        </column>

        <column sequence="81" attributecolumnid="2080">
          <rawdata>
            <value><![CDATA[${newBororwersContractor3}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${newBororwersContractor3}]]></value>
          </displaydata>
        </column>

        <column sequence="82" attributecolumnid="2081">
          <rawdata>
				<choices>
					<choice>
							<id>${contractType2 ?? ""}</id>
					</choice>
				</choices>
            </rawdata>
        </column>

        <column sequence="83" attributecolumnid="2082">
          <rawdata>
            <value><![CDATA[${newemp2}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${newemp2}]]></value>
          </displaydata>
        </column>

        <column sequence="84" attributecolumnid="2083">
          <rawdata>
            <value><![CDATA[${newemp3}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${newemp3}]]></value>
          </displaydata>
        </column>

        <column sequence="85" attributecolumnid="2084">
          <rawdata>
				<choices>
					<choice>
							<id>${contractType3 ?? ""}</id>
					</choice>
				</choices>
            </rawdata>
        </column>

        <column sequence="84" attributecolumnid="2083">
          <rawdata>
            <value><![CDATA[${newemp3}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${newemp3}]]></value>
          </displaydata>
        </column>

        <column sequence="86" attributecolumnid="2085">
          <rawdata>
            <value><![CDATA[${newInvoiceNo2}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${newInvoiceNo2}]]></value>
          </displaydata>
        </column>

         <column sequence="87" attributecolumnid="2086">
          <rawdata>
            <date><![CDATA[${newInvoiceDate2}]]></date>
          </rawdata>
          <displaydata>
            <value><![CDATA[${newInvoiceDate2}]]></value>
          </displaydata>
        </column>

        <column sequence="88" attributecolumnid="2087">
          <rawdata>
            <value><![CDATA[${subContractInvoiceAmount2 ?? ""}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${subContractInvoiceAmount2 ?? ""}]]></value>
          </displaydata>
        </column>

        <column sequence="89" attributecolumnid="2088">
          <rawdata>
            <value><![CDATA[${newInvoiceNo3}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${newInvoiceNo3}]]></value>
          </displaydata>
        </column>

        <column sequence="90" attributecolumnid="2089">
          <rawdata>
            <date><![CDATA[${newInvoiceDate3}]]></date>
          </rawdata>
          <displaydata>
            <value><![CDATA[${newInvoiceDate3}]]></value>
          </displaydata>
        </column>

        <column sequence="91" attributecolumnid="2090">
          <rawdata>
            <value><![CDATA[${subContractInvoiceAmount3 ?? ""}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${subContractInvoiceAmount3 ?? ""}]]></value>
          </displaydata>
        </column>

      </item>
	</data>
	<sheettypeid>0</sheettypeid>
	<enablesmartform>string</enablesmartform>
	<allowDeletedItemsView>string</allowDeletedItemsView>
	<allowAllColumnsInCustomView>string</allowAllColumnsInCustomView>
</isheet>`;

      const postData = async () => {
        try {
          const res = await axios.post(`${API_URL}/postb`, xmlData, {
            headers: {
              "Content-Type": "application/xml",
            },
          });

          console.log("Response_data:", res.data.progressivekey);
          console.log("xmlData", xmlData);

          const progressiveKey = res.data.progressivekey;
          // start here
          const response = await axios.post(
            `${BACKEND_URL}/getHighQResponse/${progressiveKey}`
          );
          console.log("Response_data_progresskey:", response.data);
          const msg = response.data?.[0]?.columns?.[0]?.message;

          // setStatus("iSheet successfully generated");
          setStatus(msg);

          if (msg) {
            setStatus(msg);
          } else {
            setStatus("iSheet successfully generated");
          }

          // end here

          onUploadSuccess();
          setTimeout(() => {
            setStatus(null);
          }, 5000);
          removeFile();
          removeFile2();
        } catch (error) {
          console.error("Error sending data:", error);
        }
      };

      postData();
    }
  }, [finalUpload]);

  const handleFile1Change = (e) => {
    const selectedFile = e.target.files[0];
    console.log("selectedFile:", selectedFile);
    if (selectedFile) {
      setFile(selectedFile);
      setStatusCC(null);
    }
  };

  const isRemovingRef = useRef(false);
  const isRemovingRef2 = useRef(false);

  const removeFile = () => {
    isRemovingRef.current = true;
    setFile(null);
    setStatusCC(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }
  };

  useEffect(() => {
    if (isRemovingRef.current) {
      isRemovingRef.current = false;
      return;
    }

    if (file) {
      console.log("File:", file);
      handleUploadCC();
    }

    if (errorCodeCC === "ERROR") {
      setStatusCC("Upload failed validation error");
    } else if (errorCodeCC === "OK") {
      setStatusCC("");
    }
  }, [errorCodeCC, file]);

  const handleFile2Change = (e) => {
    const selectedFile2 = setFile2(e.target.files[0]);
    console.log("selectedFile2:", selectedFile2);
    if (selectedFile2) {
      setFile2(selectedFile2);
      setStatusTF(null);
    }
  };

  const removeFile2 = () => {
    isRemovingRef2.current = true;
    setFile2(null);
    setStatusTF(null);
    setLoading(false);
    if (fileInputRef2.current) {
      fileInputRef2.current.value = "";
    }
  };

  useEffect(() => {
    if (isRemovingRef2.current) {
      isRemovingRef2.current = false;
      return; // Skip status update when removing
    }

    if (file2) {
      console.log("File:", file2);
      handleUploadTF();
    }

    if (errorCodeTF === "ERROR") {
      setStatusTF("Upload failed validation error");
      setLoading(true);
    } else if (errorCodeTF === "OK") {
      console.log("Response status:", statusRes);
      setStatusTF("");
      setLoading(false);
    }
  }, [errorCodeTF, file2]);

  return (
    <>
      <h4
        style={{ textAlign: "center", marginBottom: "10px", marginTop: "30px" }}
      >
        Upload Client Card & Transaction File
      </h4>
      <hr />
      <div
        style={{
          backgroundColor: "#f3f3f3",
          padding: "20px",
          borderRadius: "10px",
          marginBottom: "10px",
        }}
      >
        <label style={{ fontWeight: "bold" }}>
          Upload Client Card (CC) <span className="text-danger">*</span>
        </label>
        <br />
        <input type="file" onChange={handleFile1Change} ref={fileInputRef} />
      </div>

      {file && (
        <div
          style={{
            border: "1px solid #ccc",
            borderRadius: "8px",
            padding: "10px",
            marginTop: "10px",
            marginBottom: "20px",
            position: "relative",
          }}
        >
          <div>
            <p style={{ margin: "5px 0", fontWeight: "bold" }}>{file.name}</p>
            <p style={{ margin: "5px 0", color: "#555" }}>
              {(file.size / 1024).toFixed(2)} KB
            </p>
          </div>
          <button
            onClick={removeFile}
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              backgroundColor: "#f44336",
              color: "#fff",
              border: "none",
              borderRadius: "50%",
              width: "25px",
              height: "25px",
              cursor: "pointer",
            }}
          >
            &times;
          </button>
        </div>
      )}

      {statusCC && (
        <p
          style={{
            color: statusCC.includes("error")
              ? "#f44336"
              : statusCC.includes("successfully")
              ? "green"
              : "grey",
            marginTop: "-20px",
            textAlign: "center",
          }}
        >
          {statusCC}
        </p>
      )}

      <div
        style={{
          backgroundColor: "#f3f3f3",
          padding: "20px",
          borderRadius: "10px",
        }}
      >
        <label style={{ fontWeight: "bold" }}>
          Upload Transaction File (TF) <span className="text-danger">*</span>
        </label>
        <br />
        <input type="file" onChange={handleFile2Change} ref={fileInputRef2} />
      </div>

      {file2 && (
        <div
          style={{
            border: "1px solid #ccc",
            borderRadius: "8px",
            padding: "10px",
            marginTop: "10px",
            position: "relative",
          }}
        >
          <div>
            <p style={{ margin: "5px 0", fontWeight: "bold" }}>{file2.name}</p>
            <p style={{ margin: "5px 0", color: "#555" }}>
              {(file2.size / 1024).toFixed(2)} KB
            </p>
          </div>
          <button
            onClick={removeFile2}
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              backgroundColor: "#f44336",
              color: "#fff",
              border: "none",
              borderRadius: "50%",
              width: "24px",
              height: "24px",
              cursor: "pointer",
            }}
          >
            &times;
          </button>
        </div>
      )}

      {statusTF && (
        <p
          style={{
            color: statusTF.includes("error")
              ? "#f44336"
              : statusTF.includes("successfully")
              ? "green"
              : "grey",
            marginTop: "5px",
            textAlign: "center",
          }}
        >
          {statusTF}
        </p>
      )}

      <button
        onClick={handleUpload}
        disabled={loading}
        className="btn btn-primary"
        style={{ marginTop: "30px" }}
      >
        {loading
          ? "Generating isheet"
          : loading === "error"
          ? "something wrong with the files"
          : "Generate iSheet"}
      </button>

      {status && (
        <p
          style={{
            backgroundColor: status.includes("error")
              ? "#7b1103"
              : status.includes("successfully")
              ? "green"
              : "grey",
            borderRadius: "10px",
            marginTop: "10px",
            padding: "10px",
            color: "#fff",
          }}
        >
          {status}
        </p>
      )}
    </>
  );
};

export default FileUploadProductB;
